import { render, staticRenderFns } from "./EventDependencyList.vue?vue&type=template&id=20800ea1&scoped=true"
import script from "./EventDependencyList.vue?vue&type=script&lang=js"
export * from "./EventDependencyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20800ea1",
  null
  
)

export default component.exports